<script>
import Vue from 'vue'
import Nav from './components/nav'
import Footer from './components/footer'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'bootstrap'
import './scss/app.scss'

library.add(faFacebookF, faInstagram)

Vue.component('font-awesome-icon', FontAwesomeIcon)

export default {
  components: {
    Nav,
    Footer,
  },
}
</script>

<template>
  <div id="VueApp">
    <Nav></Nav>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>